module.exports = __webpack_public_path__ + "img/seedadminlogo.0bd535cd.png";